import React from 'react';
import { cn } from '@/lib/utils';

interface StandardizedIconProps {
  src?: string;
  alt: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  children?: React.ReactNode; // For Lucide icons
  contentScale?: number;
  monochrome?: boolean;
  color?: string;
  fit?: boolean;
}

const StandardizedIcon: React.FC<StandardizedIconProps> = ({
  src,
  alt,
  size = 'md',
  className,
  children,
  contentScale = 1.0,
  monochrome = true,
  color = 'currentColor',
  fit = false
}) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10', 
    lg: 'w-20 h-20',
    xl: 'w-24 h-24'
  };

  const baseClasses = cn(
    'flex items-center justify-center flex-shrink-0',
    fit ? 'w-full h-full' : sizeClasses[size],
    'overflow-hidden',
    className
  );

  if (src) {
    if (monochrome) {
      return (
        <div className={baseClasses}>
          <div
            className="w-full h-full"
            style={{
              WebkitMask: `url(${src}) no-repeat center/contain`,
              mask: `url(${src}) no-repeat center/contain`,
              backgroundColor: color,
              transform: `scale(${contentScale})`
            }}
          />
        </div>
      );
    }

    return (
      <div className={baseClasses}>
        <img
          src={src}
          alt={alt}
          className="w-full h-full object-contain"
          style={{ transform: `scale(${contentScale})` }}
        />
      </div>
    );
  }

  if (children) {
    return (
      <div className={baseClasses} style={{ color }}>
        <div style={{ transform: `scale(${contentScale})` }}>
          {children}
        </div>
      </div>
    );
  }

  return <div className={baseClasses} />;
};

export default StandardizedIcon;